module.exports = __webpack_public_path__ + "static/media/jean-paul-sponsor.29ac6960.png";